import styled from 'styled-components';

const Main = styled.div<{ isTablet: boolean; isMobile: boolean }>`
  width: 100%;
  max-width: ${(p) => (p.isMobile ? '100%' : '1200px')};
  margin: auto;
`;

const InformationWrapper = styled.div<{ isTablet: boolean; isMobile: boolean }>`
  width: ${(p) => (p.isTablet ? '100%' : '70%')};
  white-space: pre-wrap;
  background: ${(p) => p.theme.colors.light};
  ${(p) => p.theme.outsideShadowW02};
  border-radius: 15px 15px 15px 0;
  padding: ${(p) => (p.isMobile ? '15px' : '30px 50px')};
  text-align: ${(p) => (p.isMobile ? 'left' : 'justify')};

  ul {
    list-style: disc;
    padding-left: 20px;
  }

  li {
    line-height: 150%;
  }
`;

const SidebarWrapper = styled.div<{ isTablet: boolean; isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: ${(p) => (p.isTablet ? '100%' : '30%')};
  max-width: ${(p) => (p.isTablet ? 'unset' : '365px')};

  .card {
    width: 100%;
    height: min-content;
    margin: 0 auto;
    ${(p) => p.theme.outsideShadowW02};
    border-radius: 15px 15px 15px 0;
    padding: 25px;
  }
`;

const ImgBox = styled.div`
  width: 100%;
  height: 450px;
`;

const Desc = styled.p`
  margin: 50px 0;
  color: ${(p) => p.theme.colors.gray500};
  font-family: 'Roboto';
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 20px;
  text-align: justify;
`;

const ProductSerivce = styled.div`
  color: ${(p) => p.theme.colors.gray300};
  font-family: 'Roboto';
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 16px;
`;

const CompanyDetail = styled.div`
  padding-top: 30px;
  margin-top: 30px;
  border-top: 1px solid ${(p) => p.theme.colors.gray100};

  .logoBox {
    margin-bottom: 5px;
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .info {
    display: flex;
    margin-top: 15px;

    h4:first-child {
      width: 155px;
      flex-shrink: 0;
      color: ${(p) => p.theme.colors.gray300};
    }
    h4:last-child {
      flex: 1;
      color: ${(p) => p.theme.colors.gray500};

      span {
        display: block;
        margin-top: 10px;
        color: ${(p) => p.theme.colors.primary400};

        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
`;

const InfoTitle = styled.div`
  font-size: ${(p) => p.theme.fontSizes.base};
  font-weight: 700;
  color: ${(p) => p.theme.colors.primary500};
  margin-bottom: 15px;
`;

const ContentWrapper = styled.div<{ isTablet: boolean, isMobile: boolean }>`
  width: 100%;
  display: flex;
  gap: 10px;
  flex-direction: ${(p) => (p.isTablet ? 'column' : 'row')};
  justify-content: center;
  align-items: ${(p) => (p.isTablet ? 'center' : 'flex-start')};
  font-size: ${(p) => p.isMobile ? p.theme.fontSizes.sm : p.theme.fontSizes.base};
`;

const LinkText = styled.div`
  color: ${(p) => p.theme.colors.secondary500};
  text-decoration: underline;
`;

export {
  Main,
  InformationWrapper,
  SidebarWrapper,
  ImgBox,
  Desc,
  ProductSerivce,
  CompanyDetail,
  InfoTitle,
  ContentWrapper,
  LinkText
};
